module.exports = __webpack_public_path__ + "img/ico-active.216cef22.svg";